import baseReactorCoreImage from "assets/starship-base-reactor-core.svg";
import baseShieldsImage from "assets/starship-base-shields.svg";
import baseTargetingSystemImage from "assets/starship-base-targeting-system.svg";
import baseThrustersImage from "assets/starship-base-thrusters.svg";
import baseWeaponsImage from "assets/starship-base-weapons.svg";
import {
  attackAnimation,
  reactorCoreAnimation,
  shieldsAnimation,
  targetingSystemAnimation,
  thrusterAnimation,
} from "components/styles/animations";
import { UpgradeModel } from "types";
import {
  DEFAULT_REACTOR_SPEED,
  DEFAULT_SHIELDS_SPEED,
  DEFAULT_TARGETING_SPEED,
  DEFAULT_THRUSTERS_SPEED,
  DEFAULT_WEAPONS_SPEED,
} from "./constants";

const DEFAULT_UPGRADES: Record<string, UpgradeModel> = {
  default_weapons: {
    slug: "default_weapons",
    name: "Base Weapon",
    description: "Crappy weapon that came with your starship.",
    image: baseWeaponsImage,
    animation: attackAnimation,
    animationSpeed: DEFAULT_WEAPONS_SPEED,
    part: "weapons",
    requirements: {
      firepower: 0,
    },
    grade: "default",
    derivedStatsModifiers: {},
    isDefault: true,
  },
  default_shields: {
    slug: "default_shields",
    name: "Base Shield",
    description: "Crappy shield that came with your starship.",
    image: baseShieldsImage,
    animation: shieldsAnimation,
    animationSpeed: DEFAULT_SHIELDS_SPEED,
    part: "shields",
    requirements: {
      resilience: 0,
    },
    grade: "default",
    derivedStatsModifiers: {},
    isDefault: true,
  },
  default_thrusters: {
    slug: "default_thrusters",
    name: "Base Thrusters",
    description: "Crappy thrusters that came with your starship.",
    image: baseThrustersImage,
    animation: thrusterAnimation,
    animationSpeed: DEFAULT_THRUSTERS_SPEED,
    part: "thrusters",
    requirements: {
      speed: 0,
    },
    grade: "default",
    derivedStatsModifiers: {},
    isDefault: true,
  },
  default_targeting_system: {
    slug: "default_targeting_system",
    name: "Base Targeting Grid",
    description: "Crappy targeting system that came with your starship.",
    image: baseTargetingSystemImage,
    animation: targetingSystemAnimation,
    animationSpeed: DEFAULT_TARGETING_SPEED,
    part: "targetingSystem",
    requirements: {
      precision: 0,
    },
    grade: "default",
    derivedStatsModifiers: {},
    isDefault: true,
  },
  default_reactor_core: {
    slug: "default_reactor_core",
    name: "Base Reactor Core",
    description: "Crappy reactor core that came with your starship.",
    image: baseReactorCoreImage,
    animation: reactorCoreAnimation,
    animationSpeed: DEFAULT_REACTOR_SPEED,
    part: "reactorCore",
    requirements: {
      energy: 0,
    },
    grade: "default",
    derivedStatsModifiers: {},
    isDefault: true,
  },
};

export default DEFAULT_UPGRADES;
